var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9676 22.5C26.9042 22.5 27.6492 21.9106 28.3181 21.0864C29.6874 19.3993 27.4392 18.051 26.5817 17.3908C25.71 16.7195 24.7368 16.3393 23.75 16.25M22.5 13.75C24.2259 13.75 25.625 12.3509 25.625 10.625C25.625 8.89911 24.2259 7.5 22.5 7.5",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03245 22.5C3.09582 22.5 2.35083 21.9106 1.68193 21.0864C0.312611 19.3993 2.56084 18.051 3.41831 17.3908C4.28997 16.7195 5.26323 16.3393 6.25 16.25M6.875 13.75C5.14911 13.75 3.75 12.3509 3.75 10.625C3.75 8.89911 5.14911 7.5 6.875 7.5",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1048 18.889C8.82753 19.6787 5.47873 21.2914 7.51837 23.3093C8.51472 24.295 9.6244 25 11.0195 25H18.9805C20.3756 25 21.4853 24.295 22.4816 23.3093C24.5213 21.2914 21.1725 19.6787 19.8952 18.889C16.9002 17.037 13.0998 17.037 10.1048 18.889Z",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 9.375C19.375 11.7912 17.4162 13.75 15 13.75C12.5838 13.75 10.625 11.7912 10.625 9.375C10.625 6.95875 12.5838 5 15 5C17.4162 5 19.375 6.95875 19.375 9.375Z",
    stroke: "#2177FE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadlist);
export default __webpack_public_path__ + "static/media/Leadlist.b57ae732151108d850764ec68a95213d.svg";
export { ForwardRef as ReactComponent };